import { all, takeEvery, takeLatest } from 'redux-saga/effects'

import { InboxActions } from '../actions'
import { fetchEarlier } from './fetchEarlier'
import { fetchFresh } from './fetchFresh'
import { fetchUnread } from './fetchUnread'
import { markAllRead, markRead } from './markRead'
import { open } from './open'
import { fetchProjectSettings, saveProjectSettings } from './projectSettings'

export function* inboxSaga() {
  yield all([
    takeLatest(InboxActions.fetchUnread, fetchUnread),
    takeLatest(InboxActions.fetchFresh, fetchFresh),
    takeEvery(InboxActions.fetchEarlier, fetchEarlier),
    takeEvery(InboxActions.markRead, markRead),
    takeEvery(InboxActions.markAllRead, markAllRead),
    takeEvery(InboxActions.open, open),
    takeLatest(InboxActions.fetchProjectSettings, fetchProjectSettings),
    takeEvery(InboxActions.saveProjectSettings, saveProjectSettings),
  ])
}
